import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { TemplateSection, UploadedTemplate } from 'src/data-capture/hooks/templates/useTemplates';

type UpdateSectionWithInstruction = TemplateSection & {
  editMessage: string;
  editType: 'SECTION_INSTRUCTIONS' | 'SECTION_TEMPLATE_TEXT' | 'BOTH';
};

export type TemplateToUpdate = UploadedTemplate & {
  sections: TemplateSection[] | UpdateSectionWithInstruction[];
  previewClientId?: string | null;
  previewSectionId?: string | null;
};

export const useUpdateTemplate = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation<
    { data: UploadedTemplate },
    Error,
    { companyId: string; template: TemplateToUpdate }
  >({
    mutationFn: ({ companyId, template }) =>
      api.put<UploadedTemplate>(`admin/companies/${companyId}/templates/${template.id}`, template),
    onSuccess: (_data, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'companies', companyId, 'templates'] });
    },
  });

  const updateTemplate = async (companyId: string, templateToUpdate: TemplateToUpdate) => {
    const response = await mutateAsync({ companyId, template: templateToUpdate });
    return response.data;
  };

  return {
    updateTemplate,
    isLoading,
  };
};
